/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { ExtendedPaginationBox } from "@nordcloud/gnui";

type PaginationData = {
  count: number;
  small?: boolean;
  page: number;
  limit: number;
  setPageAndLimit: (page: number, limit: number) => void;
};
export function Pagination({
  count,
  small,
  page,
  setPageAndLimit,
  limit,
}: PaginationData) {
  const startByPage = (currentPage: number, pageLimit: number) =>
    currentPage / pageLimit;

  const startByLimit = (pageLimit: number) => {
    return pageLimit;
  };
  const startFrom = (currentPage: number, pageLimit: number) =>
    currentPage * pageLimit;

  const startByPageOnLimitChange = (
    newLimit: number,
    oldLimit: number,
    currentPage: number
  ) => Math.floor((oldLimit / newLimit) * currentPage);

  return (
    <ExtendedPaginationBox
      small={small}
      count={count}
      from={startFrom(page, limit)}
      setPage={(newPage) => setPageAndLimit(startByPage(newPage, limit), limit)}
      setSize={(newLimit) => {
        const newPage = startByPageOnLimitChange(newLimit, limit, page);
        setPageAndLimit(newPage, startByLimit(newLimit));
      }}
      size={limit}
    />
  );
}
